import { createSelector } from 'reselect';
import { getUgMotorInsuranceState } from './index';
import { FORM_STATUS, API_CALL_STATUS } from '../../reducers/status';

export const getPersonalDetails = createSelector(getUgMotorInsuranceState, (state) => state.personalDetails);

export const getPersonalDetailsForm = createSelector(getPersonalDetails, (personalDetails) => personalDetails.form);

export const getSelectedForm = createSelector(getPersonalDetails, (personalDetails) => personalDetails.selectedForm);
export const getOTPApiStatus = createSelector(getPersonalDetails, (personalDetails) => personalDetails.apiCallOTPStatus);
export const getValidateOTPApiStatus = createSelector(getPersonalDetails, (personalDetails) => personalDetails.validateApiCallStatus);

export const getBlacklisted = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails && personalDetails.blacklisted
);

export const getDropOffDetails = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.dropOffDetails
);

export const getPersonalDetailsFormValid = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.formStatus === FORM_STATUS.VALID
);

export const getIsApiPending = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.apiCallStatus === API_CALL_STATUS.PENDING
);

export const getIsOTPApiPending = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.apiCallOTPStatus === API_CALL_STATUS.PENDING
);

export const getIsValidateApiPending = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.validateApiCallStatus === API_CALL_STATUS.PENDING
);

export const getIsSendApiPending = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.sendApiCallStatus === API_CALL_STATUS.PENDING
);

export const getIsNiraApiPending = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.niraApiCallStatus === API_CALL_STATUS.PENDING
);

// Nationalities
export const getIsNationalityApiPending = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.natiolalityApiCallStatus === API_CALL_STATUS.PENDING
);

export const getNationalities = createSelector(getPersonalDetails, (personalDetails) => personalDetails.nationalities);

const makeGetFieldForm = (fieldId) => createSelector(getPersonalDetailsForm, (form) => form[fieldId]);

export const getEmailIsValidated = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.emailIsValidated
);

export const getIsNiraVerified = createSelector(getPersonalDetails, (personalDetails) => personalDetails.niraVerified);

export const getShowOtpModal = createSelector(getPersonalDetails, (personalDetails) => personalDetails.showOtpModal);

export const getShowNiraDetailsModal = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.showNiraResultsModal
);

export const getPersonalDetailsSubmitted = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.personalDetailsSubmitted
);

export const getDOBValue = makeGetFieldForm('dob');
export const getGenderValue = makeGetFieldForm('gender');
export const getFirstNameValue = makeGetFieldForm('firstName');
export const getMiddleNameValue = makeGetFieldForm('middleName');
export const getLastNameValue = makeGetFieldForm('lastName');
export const getPhoneNumberValue = makeGetFieldForm('phoneNumber');
export const getEmailValue = makeGetFieldForm('email');
export const getIdNumberValue = makeGetFieldForm('idNumber');
export const getTinNumberValue = makeGetFieldForm('tinNumber');
export const getPostalAddressValue = makeGetFieldForm('postalAddress');
export const getOccupationValue = makeGetFieldForm('occupation');
export const getNationalityValue = makeGetFieldForm('nationality');
export const getMaritalStatusValue = makeGetFieldForm('maritalStatus');
export const getResidentialStatusValue = makeGetFieldForm('residentialStatus');
export const getTownOrCityValue = makeGetFieldForm('townOrCity');
export const getAddressValue = makeGetFieldForm('address');
export const getIdCardNumberValue = makeGetFieldForm('idCardNumber');
export const getOtpValue = makeGetFieldForm('otp');
export const getReferredValue = makeGetFieldForm('referred');
